import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { AddressFragment, CountryFragment, OrderAddressFragment } from '../../../common/generated-types';

@Component({
    selector: 'vsf-address-form',
    templateUrl: './address-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressFormComponent implements OnChanges {

    @Input() availableCountries: CountryFragment[];
    @Input() address: OrderAddressFragment | AddressFragment;
    @Input() hideCompany = false;

    addressForm: UntypedFormGroup;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private cdr: ChangeDetectorRef,
    ) {
        this.addressForm = this.formBuilder.group({
            fullName: '',
            company: '',
            streetLine1: ['', Validators.required],
            streetLine2: '',
            city: ['', Validators.required],
            province: '',
            postalCode: ['', Validators.required],
            countryCode: ['', Validators.required],
            phoneNumber: '',
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('address' in changes && this.addressForm && this.address) {
            this.addressForm.patchValue({
                fullName: this.address.fullName || '',
                company: this.address.company || '',
                streetLine1: this.address.streetLine1 || '',
                streetLine2: this.address.streetLine2 || '',
                city: this.address.city || '',
                province: this.address.province || '',
                postalCode: this.address.postalCode || '',
                phoneNumber: this.address.phoneNumber || '',
            });
        }
        this.patchCountryCode();
        this.cdr.markForCheck();
    }

    /** Call after markAllAsTouched so OnPush form shows validation state. */
    refreshValidationUi(): void {
        this.cdr.markForCheck();
    }

    private patchCountryCode(): void {
        if (!this.addressForm || !this.availableCountries?.length) {
            return;
        }
        const country = this.address && (this.address as AddressFragment).country;
        if (country && typeof country !== 'string') {
            this.addressForm.patchValue({ countryCode: country.code });
            return;
        }
        if (country && typeof country === 'string') {
            const matchingCountry = this.availableCountries.find(c => c.name === country);
            if (matchingCountry) {
                this.addressForm.patchValue({ countryCode: matchingCountry.code });
            }
            return;
        }
        if (!this.addressForm.value.countryCode) {
            // Prefer LT for Venduro default market, else first country
            const lt = this.availableCountries.find(c => c.code === 'LT');
            this.addressForm.patchValue({
                countryCode: (lt || this.availableCountries[0]).code,
            });
        }
    }

}
